var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto"},[_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":_vm.type,"tile":"","dark":_vm.$vuetify.theme.isDark}},[_c('div',[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }